import React from 'react'
import { Button, Modal } from '../../../components'
import infogeral from './blocks/infogeral'
import problema from './blocks/problema'
import acoespropostas from './blocks/acoespropostas'
import acaoexecutada from './blocks/acaoexecutada'
import resultado from './blocks/resultado'
import recomendacao from './blocks/recomendacao'
import './detalheplanomodal.scss'

const Detalheinfogeral = infogeral
const Detalheproblema = problema
const Detalheacoespropostas = acoespropostas
const Detalheacaoexecutada = acaoexecutada
const Detalheresultado = resultado
const Detalherecomendacao = recomendacao

const detalheplanomodal = ({ open, close, planoId, loading, data, nls }) => {
  const plano = data?.plano || null
  const problemaData = data?.problema || null
  const acao = data?.acao || null
  const participantes = data?.participantes || []
  const checkResumo = data?.check_resumo || null
  const recomendacaoData = data?.recomendacao || null

  const nomePlano = plano
    ? `${nls.planLabel} ${plano.numero_plano} - ${plano.titulo_plano || ''}`
    : ''

  const ciclo = plano?.ciclo || ''
  const tipoAcao = acao?.tipo || ''
  const possuiRecomendacao = !!recomendacaoData

  const mostrarBlocoAcoesPropostas = tipoAcao === 'padrao'
  const mostrarBlocoAcaoExecutada = ciclo === 'do' || ciclo === 'check' || ciclo === 'act'
  const mostrarBlocoResultado = ciclo === 'check' || ciclo === 'act'
  const mostrarBlocoRecomendacao = ciclo === 'act' && possuiRecomendacao

  return (
    <Modal
      name='detalhe-plano'
      cy='pdca-plan-detail'
      title={nls.planDetailsTitle}
      open={open}
      close={close}
      closeText={nls.close}
      size='large'
      actions={(
        <Button
  data-cy='pdca-plan-detail-close'
  data-cy-effect='read'
  color='default'
  onClick={close}
>
  {nls.close}
</Button>
      )}
    >
      <div
  className='detalheplanomodal'
  data-cy='pdca-plan-detail-content'
  data-cy-id={planoId}
>
        {loading && (
          <div
  className='detalheplanomodal__loading'
  data-cy='pdca-plan-detail-loading'
>
            {nls.loading}
          </div>
        )}

        {!loading && plano && (
          <div className='detalheplanomodal__content'>
            <div
  className='detalheplanomodal__plan-name'
  data-cy='pdca-plan-detail-title'
>
              {nomePlano}
            </div>

            <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='general-info'
>
              <Detalheinfogeral
                plano={plano}
                nls={nls}
              />
            </div>

            <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='problem'
>
              <Detalheproblema
                problema={problemaData}
                nls={nls}
              />
            </div>

            {mostrarBlocoAcoesPropostas && (
              <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='proposed-actions'
>
                <Detalheacoespropostas
                  acao={acao}
                  nls={nls}
                />
              </div>
            )}

            {mostrarBlocoAcaoExecutada && (
              <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='executed-action'
>
                <Detalheacaoexecutada
                  acao={acao}
                  participantes={participantes}
                  catoutop={problemaData?.catoutop}
                  nls={nls}
                />
              </div>
            )}

            {mostrarBlocoResultado && (
              <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='result'
>
                <Detalheresultado
                  checkResumo={checkResumo}
                  indicadores={problemaData?.indicadores || []}
                  nls={nls}
                />
              </div>
            )}

            {mostrarBlocoRecomendacao && (
              <div
  className='detalheplanomodal__section'
  data-cy='pdca-plan-detail-section'
  data-cy-key='recommendation'
>
                <Detalherecomendacao
                  recomendacao={recomendacaoData}
                  nls={nls}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default detalheplanomodal